import type { LifeEvent } from '../../types/onelife.ts';

export const MIDDLE_AGE_EVENTS: LifeEvent[] = [
  {
    "id": "mid_01_silver_jubilee",
    "stageKey": "middle_age",
    "age": 51,
    "titleVi": "Ngân Khánh 25 Năm Bí Tích Hôn Phối",
    "descriptionVi": "Tròn 25 năm bên nhau, hai vợ chồng cùng con cháu tề tựu nơi thánh đường dâng Thánh Lễ tạ ơn Ngân khánh Bí Tích Hôn Phối.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "mid_01_a",
        "textVi": "Cùng nhắc lại lời thề ước thủy chung trong Bí Tích Hôn Phối, tạ ơn Chúa vì một phần tư thế kỷ yêu thương",
        "outcomeTextVi": "Gia đình bạn là tấm gương sáng ngời về lòng chung thủy và ân sủng của Bí Tích Hôn Phối cho cả giáo xứ.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 40,
        "addVirtue": "Gương mẫu sống trọn vẹn sự thủy chung thánh thiện của Bí Tích Hôn Phối suốt 25 năm",
        "unlockAchievement": "Ngân Khánh Hôn Phối Thánh Thiện"
      },
      {
        "id": "mid_01_b",
        "textVi": "Tổ chức chuyến hành hương gia đình tạ ơn và làm việc từ thiện giúp đỡ các mái ấm mồ côi",
        "outcomeTextVi": "Tình yêu gia đình tỏa hương thơm nhân ái đến muôn người xung quanh.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_02_silver_wedding_anniv",
    "stageKey": "middle_age",
    "age": 51,
    "titleVi": "Kỷ Niệm 25 Năm Ngày Cưới — Đám Cưới Bạc",
    "descriptionVi": "Gia đình, họ hàng và bạn bè tổ chức tiệc mừng kỷ niệm 25 năm ngày chung đôi ấm áp, hạnh phúc.",
    "category": "love",
    "choices": [
      {
        "id": "mid_02_a",
        "textVi": "Cùng nhau ôn lại những thăng trầm từ thuở tay trắng lập nghiệp",
        "outcomeTextVi": "Những giọt nước mắt hạnh phúc và nụ cười rạng rỡ làm ấm lòng cả hội trường.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 5,
        "relationsDelta": 35
      },
      {
        "id": "mid_02_b",
        "textVi": "Tặng người bạn đời chuyến du lịch nghỉ dưỡng trọn gói hai người",
        "outcomeTextVi": "Khoảng thời gian riêng tư giúp tình cảm thêm mặn nồng như thuở ban đầu.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": -25,
        "intellectDelta": 5,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_03_child_college_grad",
    "stageKey": "middle_age",
    "age": 48,
    "titleVi": "Chứng Kiến Con Tốt Nghiệp Đại Học",
    "descriptionVi": "Con lớn khoác lên mình tấm áo cử nhân, bước lên bục danh dự nhận bằng tốt nghiệp loại Giỏi.",
    "category": "family",
    "choices": [
      {
        "id": "mid_03_a",
        "textVi": "Ôm con vào lòng và lau nước mắt hạnh phúc của người làm cha/mẹ",
        "outcomeTextVi": "Mọi hy sinh, nhọc nhằn suốt hơn 20 năm qua được đền đáp xứng đáng.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Tận tụy nuôi dạy con cái nên người thành tài cho xã hội"
      },
      {
        "id": "mid_03_b",
        "textVi": "Khuyên con luôn giữ lòng khiêm tốn, biết ơn xã hội và không ngừng học hỏi",
        "outcomeTextVi": "Con bạn tiếp thu lời răn dạy và sớm khẳng định năng lực tại công sở.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_04_child_holy_matrimony",
    "stageKey": "middle_age",
    "age": 54,
    "titleVi": "Dựng Vợ Gả Chồng Cho Con Trong Bí Tích Hôn Phối",
    "descriptionVi": "Con cái trưởng thành tìm được người bạn đời đức hạnh, gia đình tổ chức lễ cưới trong Bí Tích Hôn Phối linh thiêng.",
    "category": "family",
    "choices": [
      {
        "id": "mid_04_a",
        "textVi": "Dẫn tay con trao cho người bạn đời trước bàn thờ Chúa trong Bí Tích Hôn Phối",
        "outcomeTextVi": "Lời chúc phúc chân thành của cha mẹ là nền tảng thiêng liêng cho thế hệ kế tiếp.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -30,
        "intellectDelta": 10,
        "relationsDelta": 40,
        "addVirtue": "Trao gửi gia sản đức tin và tình thương yêu vững chắc cho thế hệ cháu con"
      },
      {
        "id": "mid_04_b",
        "textVi": "Cùng thông gia xây dựng mối quan hệ hòa nhã, gắn kết hai gia tộc",
        "outcomeTextVi": "Gia đình thông gia kính trọng, hai bên thuận hòa đầm ấm.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_05_parish_patriarch_leader",
    "stageKey": "middle_age",
    "age": 50,
    "titleVi": "Hội Trưởng Hội Gia Trưởng / Các Bà Mẹ Công Giáo",
    "descriptionVi": "Giáo xứ tín nhiệm bầu bạn lãnh đạo Hội Gia Trưởng / Các Bà Mẹ Công Giáo nâng đỡ đời sống đạo đức các gia đình.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "mid_05_a",
        "textVi": "Tổ chức các buổi gặp gỡ chia sẻ kinh nghiệm giữ gìn hạnh phúc gia đình và giáo dục đức tin",
        "outcomeTextVi": "Nhiều gia đình trong xứ được thắt chặt tình cảm, không khí giáo xứ chan hòa yêu thương.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Nhiệt tâm lãnh đạo và đồng hành cùng các gia đình sống đức tin vững mạnh"
      },
      {
        "id": "mid_05_b",
        "textVi": "Thăm viếng và hỗ trợ các gia đình khó khăn, ốm đau trong giáo xứ",
        "outcomeTextVi": "Tình làng nghĩa xóm và đức bác ái Công giáo nở rộ khắp nơi.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_06_first_grandchild",
    "stageKey": "middle_age",
    "age": 55,
    "titleVi": "Niềm Vui Lên Chức Ông / Bà",
    "descriptionVi": "Tiếng khóc của đứa cháu nội/ngoại đầu tiên chào đời mang lại sinh khí rạng rỡ cho cả đại gia đình.",
    "category": "family",
    "choices": [
      {
        "id": "mid_06_a",
        "textVi": "Bế ẵm cháu bé, cất tiếng hát ru những làn điệu dân ca quê hương êm dịu",
        "outcomeTextVi": "Tình thương ông bà cháu thắm thiết, nhà cửa ngập tràn tiếng bi bô vui nhộn.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -10,
        "intellectDelta": 5,
        "relationsDelta": 40,
        "unlockAchievement": "Gia Đình Tam Đại Đồng Đường"
      },
      {
        "id": "mid_06_b",
        "textVi": "Nấu những món cháo bổ dưỡng chăm sóc con dâu / con gái hồi phục",
        "outcomeTextVi": "Tình thương yêu chu đáo khiến các con vô cùng cảm động và kính yêu cha mẹ.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Bao bọc con cháu bằng tình yêu thương vô bờ bến"
      }
    ]
  },
  {
    "id": "mid_07_executive_mentor",
    "stageKey": "middle_age",
    "age": 52,
    "titleVi": "Chuyên Gia Cố Vấn Cấp Cao (Senior Advisor)",
    "descriptionVi": "Sau hàng chục năm cống hiến, bạn chuyển giao vị trí điều hành trực tiếp sang vai trò Cố vấn chiến lược.",
    "category": "career",
    "choices": [
      {
        "id": "mid_07_a",
        "textVi": "Dành tâm huyết hướng dẫn thế hệ lãnh đạo kế cận tư duy chiến lược dài hạn",
        "outcomeTextVi": "Công ty phát triển bền vững, bạn được tôn kính như linh hồn của tổ chức.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 40,
        "intellectDelta": 30,
        "relationsDelta": 35,
        "careerTag": "Cố Vấn Chiến Lược Uy Tín"
      },
      {
        "id": "mid_07_b",
        "textVi": "Dành thêm thời gian nghỉ ngơi, chăm sóc gia đình và thú vui điền viên",
        "outcomeTextVi": "Cuộc sống cân bằng tuyệt đối giữa công việc và an yên nội tâm.",
        "healthDelta": 20,
        "happinessDelta": 35,
        "wealthDelta": 25,
        "intellectDelta": 15,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "mid_08_cardiovascular_health",
    "stageKey": "middle_age",
    "age": 46,
    "titleVi": "Kiểm Soát Bệnh Huyết Áp & Tim Mạch",
    "descriptionVi": "Bác sĩ cảnh báo bạn cần kiểm soát nghiêm ngặt chế độ ăn uống và mức độ căng thẳng tuổi ngũ tuần.",
    "category": "health",
    "choices": [
      {
        "id": "mid_08_a",
        "textVi": "Tập đi bộ 10.000 bước mỗi ngày và kiêng hoàn toàn đồ béo, đường ngọt",
        "outcomeTextVi": "Huyết áp ổn định hoàn toàn, cơ thể dẻo dai nhẹ nhõm như thời trai trẻ.",
        "healthDelta": 25,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 10
      },
      {
        "id": "mid_08_b",
        "textVi": "Tham gia câu lạc bộ dưỡng sinh và cầu lông người cao tuổi",
        "outcomeTextVi": "Có thêm nhiều bạn già tâm giao, tinh thần phấn chấn mỗi sớm mai.",
        "healthDelta": 20,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "mid_09_building_ancestral_hall",
    "stageKey": "middle_age",
    "age": 53,
    "titleVi": "Trùng Tu Nhà Thờ Họ / Thánh Đường Quê Nhà",
    "descriptionVi": "Bạn đứng ra chủ trì vận động con cháu khắp nơi đóng góp tôn tạo nhà thờ tổ tiên trang nghiêm, bền vững.",
    "category": "family",
    "choices": [
      {
        "id": "mid_09_a",
        "textVi": "Bỏ tâm sức giám sát từng nét chạm trổ, hoành phi câu đối tinh xảo",
        "outcomeTextVi": "Công trình hoàn thành uy nghiêm, dòng họ nức tiếng muôn phương về lòng hiếu kính tổ tiên.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -30,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Công đức vẹn toàn trùng tu nơi thờ tự trang nghiêm cho dòng tộc"
      },
      {
        "id": "mid_09_b",
        "textVi": "Xây dựng quỹ học bổng dòng họ gắn liền với nhà thờ tổ",
        "outcomeTextVi": "Con cháu dòng họ đời đời noi gương hiếu học, rạng danh tổ tông.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -25,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_10_caritas_soup_kitchen",
    "stageKey": "middle_age",
    "age": 49,
    "titleVi": "Quán Cơm Nụ Cười 2.000 Đồng Cho Người Lao Động",
    "descriptionVi": "Bạn tài trợ và duy trì quán cơm giá rẻ phục vụ người bán vé số, ve chai và sinh viên nghèo.",
    "category": "society",
    "choices": [
      {
        "id": "mid_10_a",
        "textVi": "Mỗi trưa thứ Ba và thứ Năm cùng bạn bè đến tự tay xới cơm phục vụ bà con",
        "outcomeTextVi": "Hàng ngàn bữa ăn ấm lòng sẻ chia, nụ cười hạnh phúc của người nghèo là niềm vui lớn nhất.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -25,
        "intellectDelta": 10,
        "relationsDelta": 40,
        "addVirtue": "Thực thi đức ái cụ thể qua từng bữa cơm no ấm cho người cùng khổ",
        "unlockAchievement": "Tấm Lòng Vàng Vì Người Nghèo"
      },
      {
        "id": "mid_10_b",
        "textVi": "Kêu gọi các doanh nghiệp nông sản cùng cung cấp thực phẩm sạch giá gốc",
        "outcomeTextVi": "Quán cơm mở rộng thành chuỗi hoạt động thiện nguyện bền vững.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_11_bonsai_gardening",
    "stageKey": "middle_age",
    "age": 47,
    "titleVi": "Thú Vui Cây Cảnh & Trà Đạo Điền Viên",
    "descriptionVi": "Góc sân nhà râm mát bóng cây tùng, cây mai, bạn học cách uốn nắn thế cây và thưởng trà sớm.",
    "category": "health",
    "choices": [
      {
        "id": "mid_11_a",
        "textVi": "Rèn luyện đức tính kiên nhẫn qua từng đường uốn cây và tỉa cành",
        "outcomeTextVi": "Tâm tính lắng đọng, bạn tìm thấy sự tĩnh tại tuyệt đối giữa dòng đời vội vã.",
        "healthDelta": 15,
        "happinessDelta": 25,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 15
      },
      {
        "id": "mid_11_b",
        "textVi": "Mời các bạn già đến đàm đạo chuyện nhân sinh bên chén trà ấm",
        "outcomeTextVi": "Tình bạn già tri kỷ thanh tao, quý mến nhau qua từng năm tháng.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_12_pilgrimage_rome_holyland",
    "stageKey": "middle_age",
    "age": 56,
    "titleVi": "Hành Hương Đất Thánh Giêrusalem & Roma",
    "descriptionVi": "Chuyến hành hương mơ ước cả đời: bước đi trên con đường Thương Khó của Chúa và viếng mộ Thánh Phêrô.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "mid_12_a",
        "textVi": "Quỳ gối suy niệm mầu nhiệm Vượt Qua trên đồi Can-vê với tâm tình sám hối sâu xa",
        "outcomeTextVi": "Đức tin của bạn được củng cố vững như bàn thạch, hiểu rõ tình yêu cứu chuộc vô bờ.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -35,
        "intellectDelta": 25,
        "relationsDelta": 25,
        "addVirtue": "Đức tin kiên vững sau chuyến hành hương kính viếng Đất Thánh Chúa Kitô"
      },
      {
        "id": "mid_12_b",
        "textVi": "Cầu nguyện cho gia đình, con cháu và quê hương tại Vương Cung Thánh Đường Thánh Phêrô",
        "outcomeTextVi": "Tâm hồn tràn trề ơn bình an thánh thiện mang về cho cả cộng đoàn quê nhà.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -30,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_13_economic_recession_support",
    "stageKey": "middle_age",
    "age": 45,
    "titleVi": "Nâng Đỡ Người Thân Qua Khủng Hoảng Kinh Tế",
    "descriptionVi": "Gia đình em út / họ hàng gặp khó khăn vướng vào nợ nần do kinh doanh thất bát.",
    "category": "family",
    "choices": [
      {
        "id": "mid_13_a",
        "textVi": "Rộng lòng hỗ trợ tài chính không tính lãi và tư vấn tái cơ cấu lại công việc",
        "outcomeTextVi": "Gia đình người thân thoát khỏi bờ vực phá sản, biết ơn bạn suốt đời.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": -25,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Thương người như thể thương thân, nâng đỡ ruột thịt lúc ngặt nghèo"
      },
      {
        "id": "mid_13_b",
        "textVi": "Tạo công ăn việc làm cho các cháu trong công ty của mình",
        "outcomeTextVi": "Các cháu có thu nhập ổn định và học được nghề mưu sinh chân chính.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_14_traditional_medicine_study",
    "stageKey": "middle_age",
    "age": 48,
    "titleVi": "Học Thuốc Nam & Dưỡng Sinh Đông Y",
    "descriptionVi": "Bạn tìm hiểu các bài thuốc dân gian Nam dược trị bệnh không dùng kháng sinh: gừng, tía tô, ngải cứu.",
    "category": "health",
    "choices": [
      {
        "id": "mid_14_a",
        "textVi": "Nghiên cứu sâu phương pháp bấm huyệt và châm cứu dưỡng sinh",
        "outcomeTextVi": "Tự chữa lành các chứng đau mỏi vai gáy cho mình và người bạn đời hiệu quả.",
        "healthDelta": 25,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 20
      },
      {
        "id": "mid_14_b",
        "textVi": "Trồng vườn cây thuốc Nam miễn phí phục vụ bà con chòm xóm",
        "outcomeTextVi": "Ai ốm cảm sốt đều có lá xông sạch, tiếng lành đồn xa khắp xã.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Dùng y thuật dân gian và thảo dược cứu giúp bà con chòm xóm"
      }
    ]
  },
  {
    "id": "mid_15_legacy_will_prep",
    "stageKey": "middle_age",
    "age": 58,
    "titleVi": "Chuẩn Bị Di Chúc Công Bằng & Yêu Thương",
    "descriptionVi": "Gần 60 tuổi, bạn chủ động lập di chúc phân định tài sản minh bạch, tránh mọi tranh chấp cho con cháu sau này.",
    "category": "family",
    "choices": [
      {
        "id": "mid_15_a",
        "textVi": "Phân chia công bằng, trích một phần cho các quỹ từ thiện và việc bác ái xã hội",
        "outcomeTextVi": "Các con đều đồng thuận, khâm phục sự sáng suốt và công tâm của cha mẹ.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 35,
        "addVirtue": "Công tâm, sáng suốt trong việc truyền thừa gia sản cho con cháu"
      },
      {
        "id": "mid_15_b",
        "textVi": "Để lại bức thư tâm huyết dặn dò các con luôn yêu thương đùm bọc lẫn nhau",
        "outcomeTextVi": "Di chúc tinh thần trở thành kim chỉ nam cho sự đoàn kết của cả dòng họ.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "mid_16_catechist_director",
    "stageKey": "middle_age",
    "age": 52,
    "titleVi": "Phụ Trách Ban Giáo Lý Viên Giáo Xứ",
    "descriptionVi": "Cha xứ trao trọng trách Trưởng Ban Giáo Lý đào tạo thế hệ giáo lý viên trẻ cho xứ đạo.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "mid_16_a",
        "textVi": "Tận tình truyền thụ kiến thức Sách Giáo Lý Hội Thánh Công Giáo và kỹ năng sư phạm",
        "outcomeTextVi": "Đội ngũ giáo lý viên năng động, các lớp thiếu nhi học giáo lý say mê, sốt sắng.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 40,
        "addVirtue": "Truyền thụ chân lý đức tin cho thế hệ măng non của Giáo hội"
      },
      {
        "id": "mid_16_b",
        "textVi": "Tổ chức các hội thi Đố Vui Thánh Kinh sôi nổi cho toàn thể thiếu nhi",
        "outcomeTextVi": "Các em nhỏ yêu mến Lời Chúa và thuộc làu các câu chuyện Tin Mừng.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_17_retirement_homecoming",
    "stageKey": "middle_age",
    "age": 59,
    "titleVi": "Xây Ngôi Nhà Vườn Nghỉ Dưỡng Nơi Chôn Nhau Cắt Rốn",
    "descriptionVi": "Sau mấy mươi năm bôn ba phố thị, bạn về lại mảnh đất quê hương dựng nếp nhà ngói ba gian bên bờ ao.",
    "category": "society",
    "choices": [
      {
        "id": "mid_17_a",
        "textVi": "Trồng vườn cây ăn trái, nuôi đàn gà và đón bạn bè quê nhà hàn huyên",
        "outcomeTextVi": "Cảnh sắc thanh bình làm dịu mát tâm hồn, sức khỏe hồi phục kỳ diệu.",
        "healthDelta": 25,
        "happinessDelta": 40,
        "wealthDelta": -30,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "unlockPlacesLived": "Làng Quê Yên Bình"
      },
      {
        "id": "mid_17_b",
        "textVi": "Đóng góp làm đường bê tông nông thôn mới và lắp đèn thắp sáng cho xóm",
        "outcomeTextVi": "Bà con lối xóm yêu quý người con thành đạt trở về làm đẹp quê hương.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": -25,
        "intellectDelta": 10,
        "relationsDelta": 40,
        "addVirtue": "Uống nước nhớ nguồn, mang phúc lộc về làm giàu đẹp quê cha đất tổ"
      }
    ]
  },
  {
    "id": "mid_18_chess_veteran_cup",
    "stageKey": "middle_age",
    "age": 54,
    "titleVi": "Hội Cờ Tướng / Cờ Vua Trung Cao Niên Toàn Quốc",
    "descriptionVi": "Bạn tham gia giải cờ tướng dành cho lứa tuổi trung niên với hàng trăm cao thủ kỳ đài.",
    "category": "education",
    "choices": [
      {
        "id": "mid_18_a",
        "textVi": "Thi triển thế trận Pháo đầu mã đội uyển chuyển đoạt cúp Vàng",
        "outcomeTextVi": "Lối cờ lão luyện, thâm sâu của bạn khiến toàn thể kỳ đàn thán phục.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 15,
        "intellectDelta": 30,
        "relationsDelta": 25,
        "unlockAchievement": "Kỳ Tiên Lão Luyện"
      },
      {
        "id": "mid_18_b",
        "textVi": "Giao lưu kết bạn với các danh thủ từ khắp ba miền Bắc - Trung - Nam",
        "outcomeTextVi": "Những buổi bình cờ đêm trăng để lại bao thi vị nhân sinh.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_19_eye_surgery_recovery",
    "stageKey": "middle_age",
    "age": 56,
    "titleVi": "Phẫu Thuật Đục Thủy Tinh Thể / Khúc Xạ Mắt",
    "descriptionVi": "Thị lực giảm sút do lão hóa, bạn tiến hành phẫu thuật Phaco hiện đại để lấy lại đôi mắt sáng.",
    "category": "health",
    "choices": [
      {
        "id": "mid_19_a",
        "textVi": "Tuân thủ nghiêm ngặt chỉ dẫn nhỏ thuốc và đeo kính bảo vệ sau mổ",
        "outcomeTextVi": "Thị lực phục hồi 10/10, bạn lại có thể đọc sách và nhìn rõ gương mặt các cháu yêu.",
        "healthDelta": 20,
        "happinessDelta": 30,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 15
      },
      {
        "id": "mid_19_b",
        "textVi": "Tài trợ 10 ca mổ mắt miễn phí cho các cụ già có hoàn cảnh khó khăn",
        "outcomeTextVi": "Đem lại ánh sáng cho người nghèo là hồng ân cao cả làm ấm lòng bạn.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": -25,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Mang lại ánh sáng cho người mù lòa, già yếu nghèo khó"
      }
    ]
  },
  {
    "id": "mid_20_reconciliation_brother",
    "stageKey": "middle_age",
    "age": 44,
    "titleVi": "Hòa Giải Bất Đồng Huynh Đệ Xưa Cũ",
    "descriptionVi": "Mối bất hòa vì đất cát cha mẹ để lại giữa anh em ruột thịt kéo dài gần mười năm.",
    "category": "family",
    "choices": [
      {
        "id": "mid_20_a",
        "textVi": "Chủ động nhường phần đất tốt cho em trai và bước đến ôm em trong nước mắt",
        "outcomeTextVi": "Máu chảy ruột mềm, tình anh em hàn gắn thiêng liêng xua tan mọi oán hận.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -20,
        "intellectDelta": 15,
        "relationsDelta": 45,
        "addVirtue": "Anh em như thể tay chân, dứt bỏ tư lợi để giữ tròn tình máu mủ",
        "unlockAchievement": "Gia Đạo Thuận Hòa"
      },
      {
        "id": "mid_20_b",
        "textVi": "Cùng nhau tổ chức giỗ cha mẹ chung một mâm cơm ấm cúng",
        "outcomeTextVi": "Linh hồn cha mẹ nơi chín suối hẳn mỉm cười thanh thản.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "mid_21_writing_memoir",
    "stageKey": "middle_age",
    "age": 58,
    "titleVi": "Viết Cuốn Hồi Ký Cuộc Đời & Bài Học Thành Bại",
    "descriptionVi": "Bạn dành những đêm mùa thu tĩnh lặng viết cuốn hồi ký ghi lại những trải nghiệm và bài học cuộc đời.",
    "category": "education",
    "choices": [
      {
        "id": "mid_21_a",
        "textVi": "In thành sách tặng con cháu làm gia bảo truyền đời",
        "outcomeTextVi": "Từng trang sách là kho báu kinh nghiệm sống vô giá cho các thế hệ tương lai.",
        "healthDelta": 0,
        "happinessDelta": 35,
        "wealthDelta": -10,
        "intellectDelta": 30,
        "relationsDelta": 35,
        "addVirtue": "Đúc kết trí tuệ và truyền thụ kinh nghiệm sống cho con cháu"
      },
      {
        "id": "mid_21_b",
        "textVi": "Được nhà xuất bản phát hành rộng rãi truyền cảm hứng cho người trẻ",
        "outcomeTextVi": "Cuốn sách lọt top bán chạy, truyền cảm hứng sống đẹp cho hàng vạn độc giả.",
        "healthDelta": 0,
        "happinessDelta": 35,
        "wealthDelta": 25,
        "intellectDelta": 30,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_22_regular_sacramental_confession",
    "stageKey": "middle_age",
    "age": 55,
    "titleVi": "Bí Tích Hòa Giải Định Kỳ Nuôi Dưỡng Tâm Hồn",
    "descriptionVi": "Đều đặn mỗi tháng, bạn đến tòa giải tội lãnh nhận ơn giao hòa của Chúa qua Bí Tích Hòa Giải.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "mid_22_a",
        "textVi": "Khiêm nhường xét mình và canh tân đời sống trong Bí Tích Hòa Giải",
        "outcomeTextVi": "Tâm hồn bạn luôn giữ được sự trong sáng, thanh thản và độ lượng với mọi người.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 30,
        "addSacrament": "Bí Tích Hòa Giải",
        "addVirtue": "Khiêm nhường đón nhận ơn tha thứ qua Bí Tích Hòa Giải đều đặn"
      },
      {
        "id": "mid_22_b",
        "textVi": "Làm việc đền tội bằng việc tha thứ vô điều kiện cho người làm tổn thương mình",
        "outcomeTextVi": "Sự bao dung giải thoát tâm can bạn khỏi mọi xiềng xích oán thù.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_23_volunteering_disaster",
    "stageKey": "middle_age",
    "age": 53,
    "titleVi": "Chỉ Huy Đội Cứu Trợ Khẩn Cấp Địa Phương",
    "descriptionVi": "Trận sạt lở đất đe dọa bản làng, với uy tín của mình, bạn đứng ra điều phối di dời dân.",
    "category": "society",
    "choices": [
      {
        "id": "mid_23_a",
        "textVi": "Thức trắng đêm chỉ đạo sơ tán kịp thời hơn 100 hộ dân đến nơi an toàn",
        "outcomeTextVi": "Toàn bộ bà con an toàn trước khi bùn đất ập xuống, bạn được chính quyền trao huy chương cứu nạn.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 45,
        "unlockAchievement": "Chỉ Huy Cứu Nạn Quả Cảm"
      },
      {
        "id": "mid_23_b",
        "textVi": "Quyên góp lương thực và dựng lều dã chiến cho các hộ mất nhà",
        "outcomeTextVi": "Sự ấm áp nghĩa tình giúp bà con không ai bị đói rét sau thiên tai.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 15,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "mid_24_celebrating_parents_90th",
    "stageKey": "middle_age",
    "age": 57,
    "titleVi": "Mừng Thượng Thượng Thọ Cha Mẹ 90 Tuổi",
    "descriptionVi": "Cha mẹ đại thọ 90 tuổi, con cháu tứ đại tề tựu đông đủ chúc thọ trong niềm xúc động nghẹn ngào.",
    "category": "family",
    "choices": [
      {
        "id": "mid_24_a",
        "textVi": "Dâng chén trà mừng thọ quỳ gối tạ ơn công ơn trời biển của đấng sinh thành",
        "outcomeTextVi": "Gia đình tứ đại đồng đường phúc đức ngập tràn, cả xóm làng ngưỡng mộ.",
        "healthDelta": 10,
        "happinessDelta": 45,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 45,
        "addVirtue": "Phúc đức tổ tiên sâu dày, con cháu hiếu thảo trọn bề gia đạo"
      },
      {
        "id": "mid_24_b",
        "textVi": "Mời linh mục dâng Thánh Lễ tạ ơn thượng thọ tại tư gia",
        "outcomeTextVi": "Ân phúc Chúa tràn trề phủ bóng trên từng thế hệ con cháu.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 40
      }
    ]
  },
  {
    "id": "mid_25_organic_farming",
    "stageKey": "middle_age",
    "age": 46,
    "titleVi": "Nông Trại Hữu Cơ & Thảo Dược Sạch",
    "descriptionVi": "Bạn xây dựng mô hình trang trại nông nghiệp tuần hoàn không phân bón hóa học.",
    "category": "career",
    "choices": [
      {
        "id": "mid_25_a",
        "textVi": "Kiên trì cải tạo đất bằng vi sinh tự nhiên, tạo ra nông sản sạch đạt chuẩn quốc tế",
        "outcomeTextVi": "Nông sản của bạn xuất khẩu sang Nhật, mang lại hiệu quả kinh tế cao và bảo vệ đất mẹ.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": 35,
        "intellectDelta": 20,
        "relationsDelta": 25
      },
      {
        "id": "mid_25_b",
        "textVi": "Chuyển giao miễn phí mô hình canh tác sạch cho nông dân quanh vùng",
        "outcomeTextVi": "Cả vùng chuyển đổi sang nông nghiệp xanh, nâng cao đời sống bà con.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 15,
        "intellectDelta": 20,
        "relationsDelta": 35,
        "addVirtue": "Bảo vệ đất mẹ và phát triển nông nghiệp xanh bền vững"
      }
    ]
  },
  {
    "id": "mid_26_overseas_charity",
    "stageKey": "middle_age",
    "age": 50,
    "titleVi": "Chuyến Công Tác Từ Thiện Vùng Cao Tây Bắc",
    "descriptionVi": "Mang áo ấm và lớp học kiên cố đến với trẻ em đồng bào Mông, Dao trên đỉnh mây mù.",
    "category": "society",
    "choices": [
      {
        "id": "mid_26_a",
        "textVi": "Xây dựng 2 điểm trường cắm bản kiên cố có điện nước và máy tính",
        "outcomeTextVi": "Mùa đông này các em nhỏ không còn phải co ro học trong lớp vách nứa dột nát.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -30,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Thắp sáng ước mơ con chữ cho trẻ em nghèo vùng cao xa xôi"
      },
      {
        "id": "mid_26_b",
        "textVi": "Hỗ trợ cây giống và kỹ thuật trồng thảo quả cho bà con thoát nghèo",
        "outcomeTextVi": "Giúp bà con có sinh kế lâu dài, tự đứng vững trên đôi chân của mình.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_27_peaceful_daily_routine",
    "stageKey": "middle_age",
    "age": 57,
    "titleVi": "Nhịp Sống Bình Dị Mỗi Ngày",
    "descriptionVi": "Thức dậy lúc 5 giờ sáng hít thở sương mai, đọc sách Thánh Kinh, tưới hoa và đi bộ cùng bạn đời.",
    "category": "health",
    "choices": [
      {
        "id": "mid_27_a",
        "textVi": "Giữ nếp sinh hoạt điều độ, thanh đạm và tràn đầy niềm vui nội tâm",
        "outcomeTextVi": "Sức khỏe dẻo dai, ánh mắt hiền từ và tâm hồn an vui lan tỏa sang mọi người.",
        "healthDelta": 25,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Sống điều độ, an nhiên tự tại giữa dòng đời biến chuyển"
      },
      {
        "id": "mid_27_b",
        "textVi": "Dành buổi chiều chơi đùa dạy cháu vẽ tranh và kể chuyện cổ tích",
        "outcomeTextVi": "Tuổi thơ của các cháu được tưới mát bằng tình yêu thương dịu dàng của ông bà.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_28_teaching_next_gen",
    "stageKey": "middle_age",
    "age": 58,
    "titleVi": "Bài Giảng Tri Ân Cuối Khóa",
    "descriptionVi": "Bạn được mời làm giáo sư thỉnh giảng chia sẻ kinh nghiệm cuộc đời cho sinh viên tốt nghiệp.",
    "category": "education",
    "choices": [
      {
        "id": "mid_28_a",
        "textVi": "Truyền tải thông điệp: \"Thành công lớn nhất của một đời người là giữ được lương tâm trong sạch và gia đình hạnh phúc\"",
        "outcomeTextVi": "Hàng trăm sinh viên đứng dậy vỗ tay không ngớt, nhiều em lấy đó làm kim chỉ nam cuộc đời.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": 10,
        "intellectDelta": 30,
        "relationsDelta": 35,
        "addVirtue": "Truyền lửa đạo đức và lý tưởng sống cao đẹp cho thế hệ trẻ"
      },
      {
        "id": "mid_28_b",
        "textVi": "Tặng 5 suất thực tập đặc biệt cho sinh viên có hoàn cảnh khó khăn nhất",
        "outcomeTextVi": "Mở ra cơ hội đổi đời cho những mầm non giàu nghị lực.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 20,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "mid_29_preparing_for_retirement",
    "stageKey": "middle_age",
    "age": 60,
    "titleVi": "Lễ Bàn Giao & Tri Ân Nghỉ Hưu",
    "descriptionVi": "Tròn 60 tuổi, bạn chính thức nhận quyết định nghỉ hưu sau gần 40 năm lao động bền bỉ.",
    "category": "career",
    "choices": [
      {
        "id": "mid_29_a",
        "textVi": "Nhận Kỷ niệm chương cống hiến trọn đời trong tiếng vỗ tay tri ân của tập thể",
        "outcomeTextVi": "Một chặng đường sự nghiệp vẻ vang khép lại trong sự kính trọng tuyệt đối.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 30,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "unlockAchievement": "Cống Hiến Trọn Đời Vinh Quang"
      },
      {
        "id": "mid_29_b",
        "textVi": "Cảm ơn đồng nghiệp và sẵn sàng bước vào chương mới thảnh thơi của tuổi già",
        "outcomeTextVi": "Tâm thế nhẹ nhõm, sẵn sàng cho những ngày tháng điền viên bên gia đình.",
        "healthDelta": 15,
        "happinessDelta": 35,
        "wealthDelta": 20,
        "intellectDelta": 10,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "mid_30_luc_thap_reflection",
    "stageKey": "middle_age",
    "age": 60,
    "titleVi": "Lục Thập Hoa Giáp — 60 Năm Một Vòng Đời",
    "descriptionVi": "Tròn một vòng hoa giáp 60 năm, bạn nhìn lại những dấu chân đã qua trên đường đời với lòng tri ân sâu sắc.",
    "category": "society",
    "choices": [
      {
        "id": "mid_30_a",
        "textVi": "Dâng Thánh Lễ tạ ơn Thiên Chúa và tri ân muôn người đã nâng đỡ mình",
        "outcomeTextVi": "Tâm hồn sáng trong thanh thản, sẵn sàng đón nhận tuổi già thanh cao, thánh thiện.",
        "healthDelta": 15,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 25,
        "relationsDelta": 35,
        "addVirtue": "Lòng tạ ơn trọn vẹn sau 60 năm thăng trầm giữa trần thế"
      },
      {
        "id": "mid_30_b",
        "textVi": "Bên mâm cơm đại gia đình có đầy đủ con cháu sum vầy",
        "outcomeTextVi": "Hạnh phúc trọn vẹn nhất của kiếp người chính là gia đình êm ấm, thuận hòa.",
        "healthDelta": 15,
        "happinessDelta": 45,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 45
      }
    ]
  }
];
